import usePermissionsCheck from '@/hooks/usePermissionsCheck';

import type { CheckPermissionsProps } from './CheckPermissions.types';

const CheckPermissions = (props: CheckPermissionsProps) => {
  const { permissions, children, logic } = props;

  return usePermissionsCheck(permissions, logic) ? children : '';
};

export default CheckPermissions;
